import {Component, Input, TemplateRef, ViewChild} from '@angular/core';
import { Placement } from '@fundamental-ngx/core/shared';
import { SwaService } from '../../../service/services/misc/swa/swa.service';
import {UisService} from "../../../service/services/misc/uis/uis.service";
import {PopoverComponent} from "@fundamental-ngx/core/popover";
import {IconProp} from "@fortawesome/fontawesome-svg-core";

@Component({
    selector: 'app-help-popover',
    templateUrl: './help-popover.component.html',
    styleUrls: ['./help-popover.component.scss'],
    standalone: false
})
export class HelpPopoverComponent {
	@Input() headerTitle: string;
	@Input() body: TemplateRef<any>;
	@Input() placement: Placement;
	@Input() width = '25rem';
	@Input() linkText: string;
	@Input() linkEmphasized = true;
	@Input() linkIconEnabled = false;
	@Input() enabled = true;
	@Input() tooltip = "More Info";
	@Input() linkTooltip = "";
	@Input() icon: IconProp = ['far', 'question-circle'];

	@ViewChild('helpPopover')
	    popover: PopoverComponent;
	isOpen = false;

	constructor(private _swaService: SwaService, private _uisService: UisService) {}

	onClick() {
	    this._swaService.sendCustomEvent(this._swaService.SWA_EVENT_TYPES.INFO_HELP_CLICKED, [this.headerTitle], []);
	    this._uisService.sendUISEvent(this._uisService.UIS_EVENT_TYPES.INFO_HELP_CLICKED + " - " + this.headerTitle, {title: this.headerTitle});
	}
	
	onClickLink() {
	    this.popover.open();
	    return false;
	}
}
